<template>
  <div class="sensor-chart-wrap">
    <div class="sensor-chart__header" :style="{ background: color }">
      <span class="title">{{ name }}</span>
    </div>
    <div class="sensor-chart">
      <div class="chart-box">
        <v-chart :options="option" :autoresize="true" :ref="name"></v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { makeOption } from '../utils';

export default {
  props: {
    name: {
      type: String,
      default: '--'
    },
    color: {
      type: String,
      default: '#00ccff'
    },
    unit: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      option: makeOption(this)
    };
  }
};
</script>

<style lang="scss">
.sensor-chart-wrap {
  width: 30%;
  margin-bottom: 10px;
  .sensor-chart__header {
    text-align: center;
    color: #000;
    padding: 5px 0;
  }
  .sensor-chart {
    padding-bottom: 55%;
    position: relative;
    .chart-box {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
